import { isArray } from 'util';
import { FaqItem } from './faq-model';
import { get } from 'lodash';
import { componentsTypes } from '../enum/componentsTypes.enum';

export enum ComponentType{
    ITEM = '_onboardingpf_componente_item',
    BOX = '_onboardingpf_componente_box',
    LINKBUTTON= '_onboardingpf_componente_linkbutton'
}

export class CMSStep {

  public title:string = '';
  public subtitle:string = '';
  public id:string = '';
  public components:any = {};
  public faqs:Array<FaqItem> = [];

  constructor(model?:any) {
    if (model) {
      this.title = model.title;
      this.subtitle = model.subtitle;
      this.id = model.id;
      this.components = this.extractComponents(model.components);
      this.faqs = this.getFAQS(this.components);
    }
  }

  extractComponents(components):any{

    let componentsParsed= {}

    if(components){
        if(isArray(components)){
            components.map(c=> {
                const compKey= c.type;
                componentsParsed[c.component[compKey].name]= { ...c.component[compKey], type: c.type, id: c.id };
            });
        }else{
            const compKey= components.type;
            componentsParsed[components.component[compKey].name]= { ...components.component[compKey], type: components.type, id: components.id };
        }
    }

    return componentsParsed;
  }

  getFAQS(components: Array<CMSCustomComponent>):Array<FaqItem>{
        return Object.entries(components)
        .filter(c=> c[1].type && c[1].type.indexOf('_onboardingpf_componente_faqitem') === 0)
        .map(faq => {
            const faqItem = new CMSFaqItem(faq[1]);
            return new FaqItem(faqItem);
        });
 }
}


export class CMSCustomComponent{
    name:string;
    id:string;
    type:string;
    eventLabel:string;
}
export class CMSInput extends CMSCustomComponent{
    hint:string;
    label:string;

    validator_required:string;
    validator_invalidFormat:string;
    validator_incorrectValue:string;

    constructor(model?:any) {
        super();
        if (model) {
            this.name = model.name;
            this.id = model.id;

            this.hint = model._onboardingpf_componente_input_hint;
            this.label = model._onboardingpf_componente_input_label;
            this.validator_required =  model._onboardingpf_componente_input_validator_required;
            this.validator_invalidFormat =  model._onboardingpf_componente_input_validator_invalidFormat;
            this.validator_incorrectValue =  model._onboardingpf_componente_input_validator_incorrectValue;
        }
    }
}


export class CMSButton extends CMSCustomComponent{

    label:string;
    isPrimary:boolean;

    constructor(model?:any) {
        super();
        if (model) {
            this.isPrimary = model._onboardingpf_componente_button_primary === 'Sim';
            this.label = model._onboardingpf_componente_button_label;
            this.name = model.name;
            this.id = model.id;
        }
    }
}


export class CMSBox extends CMSCustomComponent{

    title:string;
    description:string;
    icon:string = 'sys-004';
    hasBorder:boolean;
    constructor(model?:any) {
        super();
        if (model) {
            this.hasBorder = model._onboardingpf_componente_box_border === 'Sim';
            this.title = model._onboardingpf_componente_box_title;
            this.icon = model._onboardingpf_componente_box_icon ? model._onboardingpf_componente_box_icon :'sys-004';
            this.description = model._onboardingpf_componente_box_description;
            this.name = model.name;
            this.id = model.id;
        }
    }
}


export class CMSItem extends CMSCustomComponent{

    title?:string;
    description?:string;
    icon?:string;
    subtitle?:string;

    constructor(model?:any) {
        super();
        if (model) {
            this.title = model._onboardingpf_componente_item_title;
            this.subtitle = model._onboardingpf_componente_item_subtitle;
            this.icon = model._onboardingpf_componente_item_icon;
            this.description = model._onboardingpf_componente_item_description;
            this.name = model.name;
            this.id = model.id;
        }
    }
}

export class CMSLinkButton extends CMSCustomComponent{

    label:string;

    constructor(model?:any) {
        super();
        if (model) {
           this.label = model._onboardingpf_componente_linkbutton_label;
            this.name = model.name;
            this.id = model.id;
        }
    }
}

export class CMSFaqItem extends CMSCustomComponent{

    question:string;
    answer:string;
    isMono:string;

    constructor(model?:any) {
        super();
        if (model) {
            this.question = model._onboardingpf_componente_faqitem_question;
            this.answer = model._onboardingpf_componente_faqitem_answer;
            this.id = model.id;
            this.isMono = model._onboardingpf_componente_faqitem_isMono;
        }
    }
}



export class CMSPackageOffer extends CMSCustomComponent {
    offerId: string;
    title: string;
    value: string;
    features: Array<CMSItem>;
    disclaimers: Array<CMSItem>;
    oldValue?: string;
    additionalText?: string;
    isFeatured?: boolean;
    description: string;
    disclaimer?: string;
    details: Array<CMSItem>;
    showToStudent: boolean;
    showToNonStudent: boolean;
    hasMobileBonus: boolean;
    termSection?: CMSTermSection;

    constructor(model?: any) {
        super();

        if (!model) {
            return;
        }

        this.title = model._onboardingpf_componente_package_title;
        this.value = model._onboardingpf_componente_package_value;
        this.offerId = model._onboardingpf_componente_package_offerId;
        this.oldValue = model._onboardingpf_componente_package_oldValue;
        this.additionalText = model._onboardingpf_componente_package_additionalText;
        this.description = model._onboardingpf_componente_package_description;
        this.disclaimer = model._onboardingpf_componente_package_disclaimer;
        this.showToStudent = model._onboardingpf_componente_package_isStudent === "Sim";
        this.showToNonStudent = model._onboardingpf_componente_package_isNotStudent === "Sim";
        this.features = this.getFeatures(get(model, "_onboardingpf_componente_package_features", []));
        this.details = this.getDetails(get(model, "_onboardingpf_componente_package_details", []));
        this.disclaimers = this.getDisclaimers(get(model, "_onboardingpf_componente_package_disclaimers", []));
        this.hasMobileBonus = model._onboardingpf_componente_package_hasBonus === "Sim";
        this.termSection = new CMSTermSection(get(model, "_onboardingpf_componente_package_term_section", false));
    }


    getFeatures(components: Array<CMSCustomComponent>=[]):Array<CMSItem>{
        return components ?  Object.entries(Array.isArray(components)? components : [components])
        .map(item => {
            return new CMSItem(item[1]);
        }):[];
    }

    getDetails(components: Array<CMSCustomComponent>=[]):Array<CMSItem>{
        return  components ? Object.entries(Array.isArray(components)? components : [components])
        .map(item => {
            return new CMSItem(item[1]);
        }):[];
    }

    getDisclaimers(components: Array<CMSCustomComponent>=[]):Array<CMSItem>{
        return  components ?  Object.entries(Array.isArray(components)? components : [components])
        .map(item => {
            return new CMSItem(item[1]);
        }):[];
    }
}


export class CMSProductCard extends CMSCustomComponent{

    title:string;
    subtitle:string;
    cardId:string;
    image:CMSImage;
    benefits: Array<CMSItem>;
    detailsPeriodName: string;
    detailsPeriodPrice: string;
    detailsConditions:string;
    detailsMoreConditions:string;
    limitApproved:string;
    creditStatus:string;

    constructor(model?:any) {
        super();
        if (model) {
            this.title = model._onboardingpf_componente_productCard_title;
            this.subtitle = model._onboardingpf_componente_productCard_subtitle;
            this.image = new CMSImage(model._onboardingpf_componente_productCard_image);
            this.benefits = this.getBenefits(model._onboardingpf_componente_productCard_benefits);
            this.detailsPeriodName = model._onboardingpf_componente_productCard_details_period_name;
            this.detailsPeriodPrice = model._onboardingpf_componente_productCard_details_period_price;
            this.detailsConditions = model._onboardingpf_componente_productCard_details_conditions;
            this.detailsMoreConditions = model._onboardingpf_componente_productCard_details_more_conditions;
            this.limitApproved = model._onboardingpf_componente_productCard_limitApproved;
            this.creditStatus = model._onboardingpf_componente_productCard_credit_status;
            this.cardId = model._onboardingpf_componente_productCard_id;
            this.name = model.name;
            this.id = model.id;
        }
    }

    getBenefits(components: Array<CMSCustomComponent> = []):Array<CMSItem>{

        return components ?  Object.entries(Array.isArray(components)? components : [components])
        .filter(c=> c[1].name && c[1].name.indexOf('_onboardinglink_component_item_beneficios_') === 0)
        .map(item => {
            return new CMSItem(item[1]);
        }):[];
 }
}

export class CMSProductExpressCard extends CMSCustomComponent{

    title:string;
    code:string;
    flag:CMSCardFlag;
    logoCode:CMSLogoCode;
    function: string;
    image:CMSImage;
    caption?: string;

    constructor(model?:any) {
        super();
        if (model) {
            this.title = model._onboardingpf_componente_productExpressCard_title;
            this.image = new CMSImage(model._onboardingpf_componente_productExpressCard_image);
            this.flag = new CMSCardFlag(model._onboardingpf_componente_productExpressCard_flag);
            this.code =  model._onboardingpf_componente_productExpressCard_code;
            this.logoCode =  new CMSLogoCode(model._onboardingpf_componente_productExpressCard_logoCode);
            this.function = model._onboardingpf_componente_productExpressCard_function;
            this.caption = model._onboardingpf_componente_productCard_caption;
            this.name = model.name;
            this.id = model.id;
        }
    }
}
export class CMSImage extends CMSCustomComponent{

    DescricaoImagemProposta:string;
    GrandeImagemProposta_bloblink_:string;
    MediaImagemProposta_bloblink_:string;
    PadraoImagemProposta_bloblink_:string;

    constructor(model?:any) {
        super();
        if (model) {
            this.DescricaoImagemProposta = model.DescricaoImagemProposta;
            this.GrandeImagemProposta_bloblink_ = model.GrandeImagemProposta_bloblink_;
            this.MediaImagemProposta_bloblink_ = model.MediaImagemProposta_bloblink_;
            this.PadraoImagemProposta_bloblink_ = model.PadraoImagemProposta_bloblink_;
            this.name = model.name;
            this.id = model.id;
        }
    }
}

export class CMSCardFlag extends CMSCustomComponent{

    name:string;
    code:string;

    constructor(model?:any) {
        super();
        if (model) {
            this.name = model._onboardingpf_componente_cardFlag_name;
            this.code = model._onboardingpf_componente_cardFlag_code;
            this.id = model.id;
        }
    }
}
export class CMSLogoCode extends CMSCustomComponent{

    name:string;
    code:string;

    constructor(model?:any) {
        super();
        if (model) {
            this.name = model._onboardingpf_componente_logoCode_name;
            this.code = model._onboardingpf_componente_logoCode_code;
            this.id = model.id;
        }
    }
}

export class CMSTerm extends CMSCustomComponent{

    title:string;
    sections:  Array<CMSTermSection>;
    summary:string;

    constructor(model?:any) {
        super();
        if (model) {
            this.title = model._onboardingpf_componente_term_title;
            this.sections = this.getTermSections(model._onboardingpf_componente_term_sections)
            this.summary = model._onboardingpf_componente_term_sumary;
            this.name = model.name;
            this.id = model.id;
        }
    }

    getTermSections(components: Array<CMSCustomComponent> = []):Array<CMSTermSection>{

        return components ?  Object.entries(Array.isArray(components)? components : [components])
        .filter(c=> {
            return c[1]['subtype'] && c[1]['subtype'].indexOf('_onboardingpf_componente_section') === 0;
        })
        .map(item => {
            return new CMSTermSection(item[1]);
        }):[];
    }
}

export class CMSTermSection extends CMSCustomComponent{

    title:string;
    icon:string;
    items:Array<CMSItem>;

    constructor(model?:any) {
        super();
        if (model) {
            this.title = model._onboardingpf_componente_section_title;
            this.icon = model._onboardingpf_componente_section_icon;
            this.items = this.getTermItems(model._onboardingpf_componente_section_items);
            this.name = model.name;
            this.id = model.id;
        }
    }

    getTermItems(components: Array<CMSCustomComponent> = []):Array<CMSItem>{

        return components ? Object.entries(Array.isArray(components)? components : [components])
        .filter(c=> {
            return c[1]['subtype'] && c[1]['subtype'].indexOf('_onboardingpf_componente_item') === 0;
        })
        .map(item => {
            return new CMSItem(item[1]);
        }):[];
    }
}

export class CMSOfferCardCollection extends CMSCustomComponent{
    cardList: Array<CMSOfferCardList>;

    constructor(model?:any){

        super();

        if(!model){return;}

        this.cardList = this.getCardList(model._onboardingpf_offercard_collection);
    }

    getCardList(components: Array<CMSCustomComponent> = []):Array<CMSOfferCardList>{

        return components ?  Object.entries(Array.isArray(components)? components : [components])
        .filter(c=> {
            return c[1]['subtype'] && c[1]['subtype'].indexOf('_onboardingpf_offercard') === 0;
        })
        .map(item => {
            return new CMSOfferCardList(item[1]);
        }):[];
    }
}

export class CMSOfferCardList extends CMSCustomComponent{
    cardName: string
    cardCode: number
    image: CMSImage
    description: string
    benefits: Array<CMSItem>;
    salesTips: Array<CMSItem>;
    value: string

    constructor(model?:any){

        super();

        if(!model){return;}

        this.cardName =  model._onboardingpf_offercard_cardName;
        this.cardCode =  model._onboardingpf_offercard_cardCode;
        this.image = new CMSImage(model._onboardingpf_offercard_imageCard);
        this.description =  model._onboardingpf_offercard_description;
        this.benefits = this.getBenefits(model._onboardingpf_offercard_benefits);
        this.salesTips = this.getBenefits(model._onboardingpf_offercard_sales_tips);
        this.value =  model._onboardingpf_offercard_price;

    }

    getBenefits(components: Array<CMSCustomComponent> = []):Array<CMSItem>{

        return components ?  Object.entries(Array.isArray(components)? components : [components])
        .filter(c=> c[1].name && c[1].name.indexOf('_onboardingpf_offercard_') === 0)
        .map(item => {
            return new CMSItem(item[1]);
        }):[];
}
    getSaleTips(components: Array<CMSCustomComponent> = []):Array<CMSItem>{

        return components ?  Object.entries(Array.isArray(components)? components : [components])
        .filter(c=> c[1].name && c[1].name.indexOf('_onboardingpf_offercard_') === 0)
        .map(item => {
            return new CMSItem(item[1]);
        }):[];
}
}

export class CMSTermItem extends CMSCustomComponent{

    title:string;
    description:string;
    summary:string;
    icon:string;
    subtitle:string;

    constructor(model?:any) {
        super();
        if (model) {
            this.title = model._onboardingpf_componente_term_item_title;
            this.subtitle = model._onboardingpf_componente_term_item_subtitle;
            this.icon = model._onboardingpf_componente_term_item_icon;
            this.description = model._onboardingpf_componente_term_item_description;
            this.summary = model._onboardingpf_componente_term_item_summary;
            this.name = model.name;
            this.id = model.id;
        }
    }

}


export class CMSTextGroup extends CMSCustomComponent{

    items:  Array<CMSItem>;

    constructor(model?:any) {
        super();
        if (model) {
            this.items = this.getItems(model._onboardingpf_componente_textgroup_items);
            this.name = model.name;
            this.id = model.id;
        }
    }

    getItems(components: Array<CMSCustomComponent> = []):Array<CMSItem>{
        return components ?  Object.entries(Array.isArray(components)? components : [components])
        .map(item => {
            return new CMSItem(item[1]);
        }):[];
 }
}

export class CMSList extends CMSCustomComponent{

    items:  Array<CMSItem>;
    title: string;

    constructor(model?:any) {
        super();
        if (model) {
            this.items = this.getItems(model._onboardingpf_componente_list_items);
            this.title = model._onboardingpf_componente_list_title;
            this.name = model.name;
            this.id = model.id;
        }
    }

    getItems(components: Array<CMSCustomComponent> = []):Array<CMSItem>{
        return components ?  Object.entries(Array.isArray(components)? components : [components])
        .map(item => {
            return new CMSItem(item[1]);
        }):[];
 }
}

export class CMSListFields extends CMSCustomComponent {

    title?: string;
    description?: string;
    icon?: string;
    subtitle?: string;
    value?: string;
    credit?: string;
    debit?: string;
    gracePeriod?: string;
    franchise?: string;
    info?: string;
    label?: string;
    code?: string;
    coverage?: string;
    price?: string;

    constructor(model?: any) {
        super();
        if (model) {
            this.title = model[componentsTypes.LIST_FIELDS_TITLE];
            this.subtitle = model[componentsTypes.LIST_FIELDS_SUBTITLE];
            this.icon = model[componentsTypes.LIST_FIELDS_ICON];
            this.description = model[componentsTypes.LIST_FIELDS_DESCRIPTION];
            this.credit = model[componentsTypes.LIST_FIELDS_CREDIT];
            this.debit = model[componentsTypes.LIST_FIELDS_DEBIT];
            this.gracePeriod = model[componentsTypes.LIST_FIELDS_GRACE_PERIOD];
            this.franchise = model[componentsTypes.LIST_FIELDS_FRANCHISE];
            this.info = model[componentsTypes.LIST_FIELDS_INFO];
            this.label = model[componentsTypes.LIST_FIELDS_LABEL];
            this.value = model[componentsTypes.LIST_FIELDS_VALUE];
            this.price = model[componentsTypes.LIST_FIELDS_PRICE];
            this.code = model[componentsTypes.LIST_FIELDS_CODE];
            this.coverage = model[componentsTypes.LIST_FIELDS_COVERAGE];
            this.name = model.name;
            this.id = model.id;
        }
    }
}

export class CMSConfig extends CMSCustomComponent{

    name:string;
    value?:string;

    constructor(model?:any) {
        super();
        if (model) {
            this.name = model._onboardingpf_componente_settings_flag_name;
            this.value = model._onboardingpf_componente_settings_flag_value;
            this.id = model.id;
        }
    }
}
